export default class EntityMenuItemKind {
	static INDEX = 'INDEX';
	static CREATE_NEW = 'CREATE_NEW';
}
